(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fha-va-water-testing-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript && document.currentScript.closest('.shopify-section');
    if (!root) return;
    const targets = root.querySelectorAll('[data-reveal]');
    if (!targets.length) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    targets.forEach((el) => observer.observe(el));

    const counters = root.querySelectorAll('.pl-counter strong span[data-target]');
    const animate = (el) => {
      const target = parseInt(el.getAttribute('data-target') || '0', 10);
      const start = Date.now();
      const duration = 1600;
      const tick = () => {
        const progress = Math.min((Date.now() - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = String(Math.round(target * eased));
        if (progress < 1) requestAnimationFrame(tick);
      };
      tick();
    };
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          counters.forEach(animate);
          counterObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    const counterRoot = root.querySelector('.pl-counters');
    if (counterRoot) counterObserver.observe(counterRoot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-hero"] && !Shopify.designMode) return;
  try {
    
/* PriorityLab — lightweight, interactive WebGL background shader
   Modes: "aurora" (flowing plasma + dot mesh), "liquid" (water), "code" (digital rain), "grid".
   Mouse/touch interactive. Attach to:
     <canvas class="pl-hero__shader" data-mode="aurora" data-color="#23b5c9"></canvas>
   Degrades gracefully: if WebGL is unavailable the canvas hides and the gradient remains. */
(function(){
  'use strict';
  var FRAG = [
  'precision highp float;',
  'uniform vec2 u_res; uniform float u_time; uniform int u_mode; uniform vec3 u_col; uniform vec2 u_mouse;',
  'varying vec2 v_uv;',
  'float hash(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
  'float noise(vec2 p){vec2 i=floor(p),f=fract(p);float a=hash(i),b=hash(i+vec2(1.,0.)),c=hash(i+vec2(0.,1.)),d=hash(i+vec2(1.,1.));vec2 u=f*f*(3.-2.*f);return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}',
  'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*noise(p);p*=2.;a*=.5;}return v;}',
  'void main(){',
  '  vec2 uv=v_uv; vec2 asp=vec2(u_res.x/u_res.y,1.0);',
  '  vec2 p=uv*asp; vec2 m=u_mouse*asp;',
  '  float md=distance(p,m); float mglow=smoothstep(.6,0.,md);',
  '  vec3 col=vec3(0.);',
  '  if(u_mode==0){',                 // liquid
  '    p+=(m-p)*mglow*.25;',
  '    vec2 q=vec2(fbm(p*3.+u_time*.05),fbm(p*3.-u_time*.05+5.));',
  '    float n=fbm(p*3.+q*2.+u_time*.08);',
  '    float caustic=pow(abs(sin(n*6.2831+u_time*.5)),2.);',
  '    col=mix(vec3(.02,.15,.26),u_col,n*.75); col+=caustic*u_col*.4; col+=u_col*mglow*.3;',
  '  } else if(u_mode==1){',          // code
  '    float cols=44.; float ci=floor(uv.x*cols);',
  '    float speed=.35+hash(vec2(ci,1.))*1.1;',
  '    float row=uv.y*26.-u_time*speed+hash(vec2(ci,7.))*12.;',
  '    float y=fract(row); float cell=hash(vec2(ci,floor(row)));',
  '    float ch=step(.45,cell); float head=smoothstep(0.,.18,y)*smoothstep(.75,.12,y);',
  '    col=u_col*ch*head; col+=u_col*.05; col+=u_col*mglow*.5;',
  '  } else if(u_mode==2){',          // perspective grid
  '    vec2 c=uv-.5; float horizon=.16; float z=1./(abs(c.y-horizon)+.02);',
  '    float gx=abs(fract(c.x*z*2.+.5)-.5); float gz=abs(fract(z*.5-u_time*.3)-.5);',
  '    float line=smoothstep(.03,0.,gx)+smoothstep(.03,0.,gz);',
  '    float fade=smoothstep(0.,.45,abs(c.y-horizon)); col=u_col*line*fade*.8; col+=u_col*mglow*.3;',
  '  } else {',                       // aurora / plasma (+ dot mesh)
  '    vec2 pp=p*1.6; pp+=(m-p)*mglow*.5;',
  '    vec2 q=vec2(fbm(pp+vec2(0.,u_time*.08)),fbm(pp+vec2(5.2,-u_time*.06)));',
  '    float n=fbm(pp+q*2.5+u_time*.05); n=pow(clamp(n,0.,1.),1.15);',
  '    vec3 dark=vec3(.02,.05,.14), blue=vec3(.05,.22,.72);',
  '    col=mix(dark,blue,smoothstep(.10,.55,n));',
  '    col=mix(col,u_col,smoothstep(.5,.92,n));',
  '    col+=u_col*mglow*.45; col*=1.12;',
  '    vec2 cell=fract(uv*vec2(130.*asp.x,130.))-.5;',
  '    float dott=smoothstep(.45,.28,length(cell));',
  '    col*=mix(.80,1.0,dott);',
  '  }',
  '  gl_FragColor=vec4(col,1.);',
  '}'].join('\n');
  var VERT='attribute vec2 a_p;varying vec2 v_uv;void main(){v_uv=a_p*.5+.5;gl_Position=vec4(a_p,0.,1.);}';

  function hexToRGB(h){h=(h||'#23b5c9').replace('#','');if(h.length===3){h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];}
    var n=parseInt(h,16);return [((n>>16)&255)/255,((n>>8)&255)/255,(n&255)/255];}
  function compile(gl,t,src){var s=gl.createShader(t);gl.shaderSource(s,src);gl.compileShader(s);
    return gl.getShaderParameter(s,gl.COMPILE_STATUS)?s:null;}

  function init(canvas){
    if(canvas.dataset.plInit) return; canvas.dataset.plInit='1';
    var gl=canvas.getContext('webgl')||canvas.getContext('experimental-webgl');
    if(!gl){canvas.style.display='none';return;}
    var vs=compile(gl,gl.VERTEX_SHADER,VERT), fs=compile(gl,gl.FRAGMENT_SHADER,FRAG);
    if(!vs||!fs){canvas.style.display='none';return;}
    var pr=gl.createProgram(); gl.attachShader(pr,vs); gl.attachShader(pr,fs); gl.linkProgram(pr);
    if(!gl.getProgramParameter(pr,gl.LINK_STATUS)){canvas.style.display='none';return;}
    gl.useProgram(pr);
    var buf=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,buf);
    gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
    var loc=gl.getAttribLocation(pr,'a_p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    var uRes=gl.getUniformLocation(pr,'u_res'), uTime=gl.getUniformLocation(pr,'u_time'),
        uMode=gl.getUniformLocation(pr,'u_mode'), uCol=gl.getUniformLocation(pr,'u_col'),
        uMouse=gl.getUniformLocation(pr,'u_mouse');
    var modeMap={liquid:0,code:1,grid:2,aurora:3,plasma:3};
    var mode=modeMap[canvas.dataset.mode]!==undefined?modeMap[canvas.dataset.mode]:3;
    gl.uniform1i(uMode,mode); gl.uniform3fv(uCol,hexToRGB(canvas.dataset.color));

    // interactive pointer (smoothed)
    var target=[0.5,0.5], cur=[0.5,0.5];
    var host=canvas.closest('section')||canvas.parentElement||canvas;
    function move(e){var t=(e.touches&&e.touches[0])||e; var r=canvas.getBoundingClientRect();
      target[0]=Math.min(1,Math.max(0,(t.clientX-r.left)/r.width));
      target[1]=Math.min(1,Math.max(0,1-(t.clientY-r.top)/r.height));}
    function leave(){target[0]=0.5;target[1]=0.5;}
    host.addEventListener('mousemove',move,{passive:true});
    host.addEventListener('touchmove',move,{passive:true});
    host.addEventListener('mouseleave',leave);

    function resize(){var dpr=Math.min(window.devicePixelRatio||1,1.6);
      var w=canvas.clientWidth||canvas.offsetWidth||1, h=canvas.clientHeight||canvas.offsetHeight||1;
      canvas.width=Math.round(w*dpr); canvas.height=Math.round(h*dpr);
      gl.viewport(0,0,canvas.width,canvas.height); gl.uniform2f(uRes,canvas.width,canvas.height);}
    resize(); window.addEventListener('resize',resize);

    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible=true;
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;}).observe(canvas);}
    var start=performance.now();
    function frame(){
      if(visible){
        cur[0]+=(target[0]-cur[0])*0.06; cur[1]+=(target[1]-cur[1])*0.06;
        gl.uniform2f(uMouse,cur[0],cur[1]);
        gl.uniform1f(uTime,(performance.now()-start)/1000);
        gl.drawArrays(gl.TRIANGLES,0,3);
      }
      if(!reduce) requestAnimationFrame(frame);
    }
    if(reduce){gl.uniform2f(uMouse,0.5,0.5);gl.uniform1f(uTime,2.0);gl.drawArrays(gl.TRIANGLES,0,3);} else requestAnimationFrame(frame);
  }
  function boot(){ document.querySelectorAll('canvas.pl-hero__shader').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.plInitShaders=boot;
})();

  } catch(e) { console.error(e); }
})();
})();
